import { intersection } from 'lodash';
import React from 'react';
import { Scope } from 'src/data/scopes';
import { useAuth } from 'src/hooks/useAuth';
import { AccessDenied } from 'src/app/authorization/AccessDenied';

export interface IRoleBasedRouteProps {
  requiredScopes: Scope[];
  render: () => React.ReactNode;
  allowAll?: boolean;
}

/** @registry Renders `render()` if the current user has any of requiredScopes (or allowAll/isAdmin), otherwise renders AccessDenied. */
export const RoleBasedRoute: React.FC<IRoleBasedRouteProps> = ({
  requiredScopes,
  render,
  allowAll = false,
}) => {
  const { scopes, isAdmin } = useAuth();
  const hasAccess =
    intersection(requiredScopes, scopes).length > 0 || allowAll || isAdmin;

  if (!hasAccess) {
    return <AccessDenied requiredScopes={requiredScopes} />;
  }
  return <>{render()}</>;
};
